import { ReactElement } from "react";
import { Box, BoxProps, Stack, styled } from "@mui/material";
import { SenecBaseTheme } from "src/styles/senecBaseTheme";
import { SenecIconDialogHeader } from "src/components/modal/senec-icon-dialog/SenecIconDialogHeader";

export interface SenecIconDialogContentProps {
    title?: string;
    MainComponent?: ReactElement;
    BottomComponent?: ReactElement;
    icon?: ReactElement;
    "data-testid"?: string;
    onClose: () => void;
    showCloseButton?: boolean;
    headerSize?: "small" | "medium";
    width?: number;
}
export const SenecIconDialogContent = ({
    title,
    MainComponent,
    BottomComponent,
    icon,
    onClose,
    "data-testid": dataTestId,
    showCloseButton = true,
    headerSize = "medium",
    width,
}: SenecIconDialogContentProps) => {
    return (
        <Stack direction={"column"} data-testid={dataTestId} paddingX="1.5rem" width={width}>
            <StickyHeader>
                <SenecIconDialogHeader
                    icon={icon}
                    title={title}
                    onClose={onClose}
                    showCloseButton={showCloseButton}
                    headerSize={headerSize}
                />
            </StickyHeader>
            {MainComponent && (
                <Box overflow={"auto"} paddingBottom={"1.5rem"}>
                    {MainComponent}
                </Box>
            )}
            {BottomComponent && (
                <StickyFooter>
                    <Box paddingBottom={"1.5rem"}>{BottomComponent}</Box>
                </StickyFooter>
            )}
        </Stack>
    );
};

const StickyHeader = styled(Box)<BoxProps>(({ theme }) => {
    const senecBaseTheme = theme as SenecBaseTheme;
    return {
        position: "sticky",
        zIndex: 1,
        top: 0,
        paddingTop: "1.25rem",
        paddingBottom: "1.5rem",
        background: senecBaseTheme.palette.white.main,
    };
});

const StickyFooter = styled(Box)<BoxProps>(({ theme }) => {
    const senecBaseTheme = theme as SenecBaseTheme;
    return {
        position: "sticky",
        zIndex: 1,
        bottom: 0,
        background: senecBaseTheme.palette.white.main,
    };
});
